export default "__VITE_ASSET__Db6jmst___"